import { IRList } from '@rhybus/api'

import { mpfRListsHttp } from '../../api/mpf-r-lists-http'

export async function UploadFiles(
  list: IRList,
  listname: Blob | string,
  itemkey: Blob | string,
  mdata: Blob | string,
  etag: string,
  file: File,
  blobFolder: Blob | string
) {
  const formData = new FormData()
  formData.append('listName', listname)
  formData.append('itemKey', itemkey)
  formData.append('metadata', mdata)
  formData.append('blobName', file.name)
  formData.append('etag', etag ?? '')
  formData.append('blobFolder', blobFolder)
  formData.append('file', file)

  try {
    const fileblob = await list.blobs().addOrUpdateByFormData(formData)
    return fileblob
  } catch (error) {
    console.error(error)
    //TODO: 4641 - Error message
  }
}
export const getMetadata = (file: File, createdBy?: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const metadata: any = []
  metadata.push({ Key: 'name', Value: file.name })
  metadata.push({ Key: 'size', Value: String(file.size) })
  metadata.push({ Key: 'type', Value: String(file.type) })
  metadata.push({ Key: 'createdby', Value: createdBy })

  return JSON.stringify(metadata)
}

export const listAttachments = async (
  listName: string,
  itemKey: string,
  files: File[]
) => {
  const list = await mpfRListsHttp().getList(listName)
  const blobFolder = '/'
  for (const element of files) {
    const file = element
    const etag = ''
    const mData = getMetadata(file)
    await UploadFiles(list, listName, itemKey, mData, etag, file, blobFolder)
  }
}
